// @flow
import React from 'react';

import { useRouterParamsE } from 'app/common/context/WithRouterParams';

import CatalogItems from './CatalogItems/CatalogItems';
import ProductDetails from './ProductDetails/ProductDetails';


const Items = () => {
  const { params, push, baseUrl } = useRouterParamsE([
    'productSlug',
    'category',
    'product',
  ]);
  console.log(params);

  return (
    <CatalogItems params={params} push={push} baseUrl={baseUrl} />
  );
};

const Details = () => {
  const { params, push, baseUrl } = useRouterParamsE([
    'productSlug',
    'category',
    'product',
  ]);

  return (
    <ProductDetails params={params} push={push} baseUrl={baseUrl} />
  );
};

export { Items, Details };
